import { SearchColumnDef } from '@/components/custom/erp';

/**
 * Search column definitions for the account search field
 */
export const accountSearchColumns: SearchColumnDef[] = [
  { field: 'code', headerName: 'Mã tài khoản', flex: 1 },
  { field: 'name', headerName: 'Tên tài khoản', flex: 2 },
  {
    field: 'parent_account_code',
    headerName: 'Tài khoản mẹ',
    flex: 2,
    renderCell: (params: BanHangTableParams) => {
      return params.row.parent_account_code_data?.code;
    }
  },
  {
    field: 'tk_so_cai',
    headerName: 'Tk sổ cái',
    type: 'boolean',
    flex: 1,
    checkboxSelection: true
  },
  {
    field: 'tk_chi_tiet',
    headerName: 'Tk chi tiết',
    type: 'boolean',
    flex: 1,
    checkboxSelection: true
  },
  {
    field: 'bac_tk',
    headerName: 'Bậc tk',
    type: 'number',
    flex: 1
  }
];

/**
 * Search column definitions for the customer search field
 */
export const customerSearchColumns = [
  {
    field: 'customerCode',
    headerName: 'Mã đối tượng',
    width: 120
  },
  {
    field: 'customerName',
    headerName: 'Tên đối tượng',
    width: 200
  },
  {
    field: 'receivable',
    headerName: 'Công nợ p/thu',
    width: 120
  },
  {
    field: 'payable',
    headerName: 'Công nợ p/trả',
    width: 120
  },
  {
    field: 'taxCode',
    headerName: 'Mã số thuế',
    width: 120
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 150
  },
  {
    field: 'phone',
    headerName: 'Số điện thoại',
    width: 120
  }
];
